/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-09-06 13:53:28
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-01 10:13:59
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Form,
  Row,
  Select,
  Space,
  Cascader as Cascaded,
  Input,
} from 'antd'
import moment from 'moment'
import React, { ReactElement, useEffect, useState, } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectTenantId, selectChainId, selectChainType } from '../../../app/applicationSlice'
import { RootDispatch } from '../../../app/store'
import {
  DateSelect,
} from '../../../compnents/form/DateSelect'
import { DateTimeFormatSimpleOnly, DateTimeFormatSimple } from '../../../models/datetime'
import { getChainTenantListFn } from '../../chainTransferApplication/chainSlice'
import styles from './TIManagement.module.css'

export const Query = (props: {
  loading?: any
  add: () => void
  onValueChange: (params: any) => void
}): ReactElement => {
  const [form] = Form.useForm()

  const { Option } = Select

  const dispatch = useDispatch<RootDispatch>()

  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const chainType = useSelector(selectChainType)

  const [chainList, setChainList] = useState<any>([])

  useEffect(() => {
    if (tenantId == chainId) {
      dispatch(getChainTenantListFn())
        .then(unwrapResult)
        .then((res: any) => {
          setChainList(res?.records)
        })
    }
  }, [])


  return (
    <Form
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
      autoComplete='off'
      form={form}
      onFinish={(values) => {
        if (!values?.timeHead && values?._dateRange == 6) {
          return
        }
        const startTime = values?.timeHead
          ? moment(values?.timeHead)?.format(DateTimeFormatSimple)
          : undefined
        const endTime = values?.timeTail
          ? moment(values?.timeTail)?.format(DateTimeFormatSimple)
          : undefined
        props.onValueChange({
          ...values,
          endTimeStart: startTime,
          endTimeEnd: endTime,
          timeHead: undefined,
          timeTail: undefined,
        })
      }}
    >
      <Row
        style={{ marginBottom: 10, width: '100%' }}
        align='middle'
        justify='space-between'
      >
        <Space>
          <DateSelect
            allowClear
            style={{ width: '8rem' }}
            labelPrefix=''
            placeholder='开始日期'
            namePrefix='time'
            onChange={() => {
              form.submit()
            }}
          />
          <Form.Item name='sponsorUnit' noStyle>
            <Input
              allowClear={true}
              placeholder='主办单位'
              style={{ width: '8rem' }}
              onChange={() => {
                form.submit()
              }}
            />
          </Form.Item>
          {(tenantId == chainId && chainType >= 0) ? (
            <Form.Item name='tenantId' noStyle>
              <Select
                placeholder={'选择门店'}
                allowClear
                showSearch
                dropdownClassName={styles.select}
                style={{ width: '16rem' }}
                optionFilterProp='children'
                onChange={form.submit}
              >
                {chainList?.map((v: any, i: any) => {
                  return (
                    <Option value={v.id} key={i}>
                      {v.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          ) : (
            ''
          )}
          <Button
            loading={props?.loading}
            type='primary'
            onClick={() => {
              form.submit()
            }}
          >
            查询
          </Button>
        </Space>
        <Space>
          <Button
            type='primary'
            onClick={() => {
              props?.add && props?.add()
            }}
          >
            添加
          </Button>
        </Space>
      </Row>
    </Form>
  )
}
